var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnWriteWithPlus = function SvgIcnWriteWithPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36417 19.6834L5.0758 16.3241L12.25 7.8461L15.912 10.9188L8.73773 19.3969L5.36417 19.6834ZM16.9455 9.69745L19.0074 7.26089L15.3455 4.18817L13.2836 6.62472L16.9455 9.69745ZM9.67619 20.7647C9.5858 20.8715 9.45652 20.9382 9.31681 20.9501L4.42915 21.3653C4.13858 21.39 3.88303 21.1755 3.85819 20.8862L3.4404 16.0192C3.42846 15.8801 3.47253 15.7419 3.56291 15.6351L14.1315 3.14581C14.6959 2.47893 15.6958 2.39354 16.3651 2.95508L20.0549 6.05121C20.7241 6.61275 20.8091 7.60858 20.2448 8.27546L9.67619 20.7647Z",
    fill: "#57595E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5002 15.1992C18.942 15.1992 19.3002 15.5574 19.3002 15.9992V20.9992C19.3002 21.441 18.942 21.7992 18.5002 21.7992C18.0584 21.7992 17.7002 21.441 17.7002 20.9992V15.9992C17.7002 15.5574 18.0584 15.1992 18.5002 15.1992Z",
    fill: "#57595E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2002 18.4988C15.2002 18.057 15.5584 17.6988 16.0002 17.6988H21.0002C21.442 17.6988 21.8002 18.057 21.8002 18.4988C21.8002 18.9407 21.442 19.2988 21.0002 19.2988H16.0002C15.5584 19.2988 15.2002 18.9407 15.2002 18.4988Z",
    fill: "#57595E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnWriteWithPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_write_with_plus.eb4817a4.svg";
export { ForwardRef as ReactComponent };